import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TaFormlyFieldWrapperModule } from '@ta-formly/ta-field-wrapper/ta-field-wrapper.module';
import { FormlyModule } from '@ngx-formly/core';

import { TaESignatureComponent } from './ta-e-signature.type';

@NgModule({
    declarations: [TaESignatureComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,

        TaFormlyFieldWrapperModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-e-signature',
                    component: TaESignatureComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlyESignatureModule { }
